export default class Button {
  constructor(el) {
    this.el = el
    this.svg = el.querySelector('.btn--picto svg')
    this.init()
  }

  init() {
    if (!this.svg) return

    this.el.addEventListener('mouseenter', () => this.onEnter())
    this.el.addEventListener('mouseleave', () => this.onLeave())
    this.svg.addEventListener('animationend', () => this.onAnimEnd())
  }

  onEnter() {
    this.svg.classList.remove('is-settled')
    this.svg.classList.add('is-entering')
  }

  onLeave() {
    this.svg.classList.remove('is-entering', 'is-settled')
  }

  onAnimEnd() {
    this.svg.classList.remove('is-entering')
    this.svg.classList.add('is-settled')
  }
}
